import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import { useManualQuery } from 'graphql-hooks'

import * as logger from '../../../../services/logger'

import IntlMessages from '../../../../util/IntlMessages'
import { FrontendUrls } from '../../../../types/urls'
import { PageHeader } from '../../../../design-system/PageHeader'
import { redirectIfEntityNotFound } from '../../../../util/entity-not-found-redirect'

import { IGetLocationById } from '../../../../types/locations'
import { getLocationById } from '../../../../graphql/custom-queries'
import LocationHolidayForm from '../../../../components/location-holiday-form'
import CircularProgress from '../../../../components/circular-progress'
import { userHasDefaultWorkingHours } from '@vacationtracker/shared/functions/work-week'

interface IAddHolidaysPage {
  match: {
    params: {
      locationId: string
      holidayId?: string
    }
  }
}

const AddHolidayPage = ({ match }: IAddHolidaysPage): React.ReactElement => {
  const history = useHistory()
  const [location, setLocation] = useState<IGetLocationById>()
  const [isLoading, setIsLoading] = useState(true)

  const [getLocation] = useManualQuery<{ getLocation: IGetLocationById }, { id: string }>(getLocationById)

  useEffect(() => {
    fetchLocation(match.params.locationId)
  }, [match.params.locationId])

  const fetchLocation = async (id: string) => {
    try {
      const response = await getLocation({ variables: { id } })
      if (!response.data || response.error) throw response.error
      if (!redirectIfEntityNotFound(response.data.getLocation, FrontendUrls.locations, history)) return
      setLocation(response.data.getLocation)
      setIsLoading(false)
    } catch (err) {
      logger.error('error fetching location', err)
    }
  }

  return (
    <div className="main-content form-background">
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <PageHeader
            title={<IntlMessages id={match.params.holidayId ? 'components.createHolidaysForm.titleEdit' : 'components.createHolidaysForm.title'} />}
            parent={[
              { label: <IntlMessages id="app.locations" />, to: FrontendUrls.locations },
              { label: location?.name, to: `/app/settings/locations/${location?.id}/holidays` },
            ]}
          />
          <div className="main-content-body">
            <LocationHolidayForm
              locationId={location?.id as string}
              locationName={location?.name as string}
              workWeek={location?.workWeek as number[]}
              defaultWorkingHours={userHasDefaultWorkingHours(location?.workHours)}
              existingLocationHolidays={location?.holidays || []}
              existingHolidayId={match.params.holidayId}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default AddHolidayPage
